import { render, staticRenderFns } from "./BuildManager.vue?vue&type=template&id=970733b6&scoped=true"
import script from "./BuildManager.vue?vue&type=script&lang=js"
export * from "./BuildManager.vue?vue&type=script&lang=js"
import style0 from "./BuildManager.vue?vue&type=style&index=0&id=970733b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970733b6",
  null
  
)

export default component.exports